<template>
  <div class="border rounded">
    <div class="p-2 border-b rounded-t bg-gray-50">
      <button type="button" class="mr-2 btn btn-sm btn-secondary" @click="selectAll()">Select All</button>
      <button type="button" class="btn btn-sm btn-secondary" @click="deselectAll()">Deselect All</button>
    </div>
    <div v-if="loading" class="p-8">
      <Loading />
    </div>
    <div class="p-2 overflow-auto h-80" v-else>
      <label class="flex items-center p-2 rounded-lg cursor-pointer hover:bg-gray-50" v-for="vehicle in vehicles.data" :key="vehicle.id">
        <toggle 
          :value="isInArray(vehicle.id)" 
          :name="vehicle.id.toString()" 
          @change="toggleVehicle(vehicle)"
          class="mb-0 mr-3" />
        <span class="mr-2">{{ vehicle.objectname }} </span>
        <small class="text-gray-500">{{ vehicle.objectno }}</small>
      </label>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'VehicleToggle',

    created () {
      this.getVehicles()
    },

    props: {
      parent: {
        type: Object
      }
    },

    data () {
      return {
        loading: true,
        vehicles: {}
      }
    },

    methods: {
      isInArray (id) {
        return this.parent.vehicles.some(vehicle => vehicle.id === id)
      },

      toggleVehicle (id) {
        this.$emit('toggle', id)
      },

      selectAll () {
        this.$emit('select-all', this.vehicles.data)
      },

      deselectAll () {
        this.$emit('deselect-all')
      },

      async getVehicles () {
        try {
          const { data } = await this.$api.get(`account/${this.$route.params.account}/vehicles`, {
            params: {
              limit: 1000
            }
          })
          this.vehicles = data.vehicles
          this.loading = false
        } catch (error) {
          console.error(error)
        }
      }
    }
  }
</script>